import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CsPage, NavController } from 'providers/nav-controller';
import { ModalPageMarker } from 'providers/modal-page-marker';
import { LL } from 'i18n/i18n.service';
import { PurchaseSuccessPageParams } from './purchase-success-interface';

@Component({
  selector: 'page-purchase-success',
  templateUrl: 'purchase-success.html',
  styleUrls: ['purchase-success.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: ModalPageMarker, useValue: new ModalPageMarker({ width: 480, height: 'auto' }) }]
})
export class PurchaseSuccessPage extends CsPage<PurchaseSuccessPageParams> {
  protected LL = LL;

  get androidInstallUrl(): string | undefined {
    return this.navParams.data?.androidInstallUrl;
  }

  get iosInstallUrl(): string | undefined {
    return this.navParams.data?.iosInstallUrl;
  }

  constructor(public navCtrl: NavController) {
    super();
  }

  onContinueClick(): void {
    void this.navCtrl.popAsync();
  }
}
